module.exports = __webpack_public_path__ + "img/ChiyokoTanaka-Jin-SookSo.9c26bd7c.jpg";